module.exports = __webpack_public_path__ + "static/img/gekanuo.021220c6.jpg";